import useMediaQuery from "../../utils/media-queries";
import { Logo } from "../Logo";
import { Navigation } from "./Navigation";
import { SocialIcons } from "./SocialIcons";

import {
  Container,
  LogoContainer,
  NavigationContainer,
  HeaderRight,
} from "./styles";

export function Header({ links, socialLinks }) {
  const { isDesktop } = useMediaQuery();

  return (
    <Container>
      <LogoContainer>
        <Logo name="Periscope" size={isDesktop ? "normal" : "small"} />
      </LogoContainer>
      <NavigationContainer>
        <Navigation links={links} active="/home" />
      </NavigationContainer>
      {isDesktop && (
        <HeaderRight>
          <SocialIcons links={socialLinks} />
        </HeaderRight>
      )}
    </Container>
  );
}
